<template>
	<div></div>
</template>

<script>
import { AUTH_SET_ACCOUNT_TOKEN } from '../store/actions/auth'
import { INIT_GET } from '../store/actions/init'

export default {

  beforeRouteEnter (to, from, next) {
    const accountId = to.params.accountId
    const shareToken = to.params.shareToken

    next(vm => {
      vm.$store.dispatch(AUTH_SET_ACCOUNT_TOKEN, shareToken).then(() => {
        vm.$store.dispatch(INIT_GET).then(() => {
          next({
            name: 'account-dashboard',
            params: {
              id: accountId
            }
          })
        })
      })
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/AccountShare.vue